import React, { useState, useEffect } from "react";
import { notificarError } from "../Almacenes/AlmacenNotify";

const DEFAULT_CODE = "";

function UbigeoSelector({ onChange, initialUbigeo }) {
    const [ubigeos, setUbigeos] = useState([]);

    const [region, setRegion] = useState(DEFAULT_CODE);
    const [provincia, setProvincia] = useState(DEFAULT_CODE);
    const [distrito, setDistrito] = useState(DEFAULT_CODE);

    const [regiones, setRegiones] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [distritos, setDistritos] = useState([]);

    const [currentUbigeo, setCurrentUbigeo] = useState(initialUbigeo);

    const decomposeUbigeo = (ubigeoCode) => {
        if (!ubigeoCode || typeof ubigeoCode !== 'string' || ubigeoCode.length !== 6) {
            return { region: DEFAULT_CODE, provincia: DEFAULT_CODE, distrito: DEFAULT_CODE };
        }
        
        return {
            region: ubigeoCode.substring(0, 2),
            provincia: ubigeoCode.substring(2, 4),
            distrito: ubigeoCode.substring(4, 6)
        };
    };

    useEffect(() => {
        fetchUbigeos();
    }, []);

    useEffect(() => {
        updateRegiones();
    }, [ubigeos]);

    useEffect(() => {
        if (ubigeos.length > 0 && initialUbigeo) {
            const { region: initialRegion, provincia: initialProvincia, distrito: initialDistrito } = decomposeUbigeo(initialUbigeo);
            
            const regionExists = ubigeos.some(ubigeo => 
                ubigeo.CodRegion === initialRegion && 
                ubigeo.CodProvincia === '00' && 
                ubigeo.CodDistrito === '00'
            );
            
            const provinciaExists = ubigeos.some(ubigeo => 
                ubigeo.CodRegion === initialRegion && 
                ubigeo.CodProvincia === initialProvincia && 
                ubigeo.CodDistrito === '00'
            );
            
            const distritoExists = ubigeos.some(ubigeo => 
                ubigeo.CodRegion === initialRegion && 
                ubigeo.CodProvincia === initialProvincia && 
                ubigeo.CodDistrito === initialDistrito
            );

            if (regionExists) {
                setRegion(initialRegion);

                const provinciasFiltradas = ubigeos.filter(ubigeo => 
                    ubigeo.CodRegion === initialRegion && 
                    ubigeo.CodProvincia !== '00' && 
                    ubigeo.CodDistrito === '00'
                );
                setProvincias(provinciasFiltradas);
                
                if (provinciaExists) {
                    setProvincia(initialProvincia);

                    const distritosFiltrados = ubigeos.filter(ubigeo => 
                        ubigeo.CodRegion === initialRegion && 
                        ubigeo.CodProvincia === initialProvincia && 
                        ubigeo.CodDistrito !== '00'
                    );
                    setDistritos(distritosFiltrados);
                    
                    if (distritoExists) {
                        setDistrito(initialDistrito);
                    }
                }
            }
        }
    }, [ubigeos, initialUbigeo]);

    useEffect(() => {
        if (!initialUbigeo || region !== decomposeUbigeo(initialUbigeo).region) {
            setProvincias([]);
            setProvincia(DEFAULT_CODE);
            setDistrito(DEFAULT_CODE);
            setDistritos([]);

            if (region !== DEFAULT_CODE) {
                updateProvincias();
            }
        }
    }, [region, initialUbigeo]);

    useEffect(() => {
        if (!initialUbigeo || provincia !== decomposeUbigeo(initialUbigeo).provincia) {
            setDistrito(DEFAULT_CODE);
            setDistritos([]);

            if (provincia !== DEFAULT_CODE) {
                updateDistritos();
            }
        }
    }, [provincia, initialUbigeo]);

    useEffect(() => {
        if (distrito !== DEFAULT_CODE) {
            const ubigeoCode = region + provincia + distrito;
            onChange && onChange(ubigeoCode) && setCurrentUbigeo(ubigeoCode);
        }
    }, [distrito, region, provincia, onChange]);

    const updateRegiones = () => {
        const regiones = ubigeos.filter(ubigeo => 
            ubigeo.CodRegion !== '00' && 
            ubigeo.CodProvincia === '00' && 
            ubigeo.CodDistrito === '00'
        );
        setRegiones(regiones);
    }

    const updateProvincias = () => {
        const provincias = ubigeos.filter(ubigeo => 
            ubigeo.CodRegion === region && 
            ubigeo.CodProvincia !== '00' && 
            ubigeo.CodDistrito === '00'
        );
        setProvincias(provincias);
    }

    const updateDistritos = () => {
        const distritos = ubigeos.filter(ubigeo => 
            ubigeo.CodRegion === region && 
            ubigeo.CodProvincia === provincia && 
            ubigeo.CodDistrito !== '00'
        );
        setDistritos(distritos);
    }

    const fetchUbigeos = async () => {
        try {
            const req = await fetch(`/api/clientes/ubigeos`);

            if (!req.ok) {
                notificarError('No se pudieron obtener los ubigeos.');
                return;
            }

            const data = await req.json();
            setUbigeos(data.results);
        } catch (error) {
            notificarError('Error al cargar los ubigeos.');
        }
    }

    return (
        <div className="d-flex">
            <select 
                className="input__linea" 
                value={region}
                onChange={(e) => setRegion(e.target.value)}
            >
                <option value={DEFAULT_CODE} disabled>Seleccione región</option>
                {
                    regiones.map(regionItem => (
                        <option key={regionItem.CodRegion} value={regionItem.CodRegion}>
                            {regionItem.NombreUbigeo}
                        </option>
                    ))
                }
            </select>
            <select 
                className="input__linea" 
                value={provincia}
                onChange={(e) => setProvincia(e.target.value)}
                disabled={region === DEFAULT_CODE}
            >
                <option value={DEFAULT_CODE} disabled>Seleccione provincia</option>
                {
                    provincias.map(provinciaItem => (
                        <option key={provinciaItem.CodProvincia} value={provinciaItem.CodProvincia}>
                            {provinciaItem.NombreUbigeo}
                        </option>
                    ))
                }
            </select>
            <select 
                className="input__linea" 
                value={distrito}
                onChange={(e) => setDistrito(e.target.value)}
                disabled={provincia === DEFAULT_CODE}
            >
                <option value={DEFAULT_CODE} disabled>Seleccione distrito</option>
                {
                    distritos.map(distritoItem => (
                        <option key={distritoItem.CodDistrito} value={distritoItem.CodDistrito}>
                            {distritoItem.NombreUbigeo}
                        </option>
                    ))
                }
            </select>
        </div>
    );
}

export default UbigeoSelector;